/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ platform: NonNullable<unknown> }} Gc_Resources_Download_For_PlatformInputs */

const en_gc_resources_download_for_platform = /** @type {(inputs: Gc_Resources_Download_For_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`GridCraft for ${i?.platform}`)
};

const zh_gc_resources_download_for_platform = /** @type {(inputs: Gc_Resources_Download_For_PlatformInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`适用于 ${i?.platform} 的 GridCraft`)
};

/**
* | output |
* | --- |
* | "GridCraft for {platform}" |
*
* @param {Gc_Resources_Download_For_PlatformInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_for_platform = /** @type {((inputs: Gc_Resources_Download_For_PlatformInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_For_PlatformInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_for_platform(inputs)
	return zh_gc_resources_download_for_platform(inputs)
});
export { gc_resources_download_for_platform as "gc.resources.download.for_platform" }